import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import CustomerNavigationLink from './CustomerNavigationLink'
import logo from '@assets/icons/logo.svg'
import logoColor from '@assets/icons/logo_color.svg'
import CaarlTourOverlay from '@components/CaarlTourOverlay'
import { deactivateCaarlTour } from '../../../actions/ui'

import '../../layout/mainNav.sass'
import './customer-navigation.sass'
import axiosClient from '../../../api/axios-client'

const unpaidExceptionRegex = /julien\.chever\+.*@3j.*\.fr/

class CustomerNavigation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      opened: false,
      lackPayment: false,
    }
  }

  closeMenu() {
    this.setState({ opened: false })
  }

  toggleMenu() {
    this.setState({ opened: !this.state.opened })
  }

  isPaymentStatusUnpaid() {
    const { currentUser } = this.props
    if (!currentUser) return false
    return currentUser.unpaidInvoices.length > 0 && !currentUser.email.match(unpaidExceptionRegex)
  }

  renderLogo() {
    return (
      <div className="mt-6 ml-6 mb-12">
        <Link to={`/`} className="logo-link">
          <img src={logo} alt="logo" />
        </Link>
      </div>
    )
  }

  renderMobileLogo(white = false) {
    return (
      <div className="">
        <Link to={`/`} className="logo-link">
          <img src={white ? logo : logoColor} alt="logo" />
        </Link>
      </div>
    )
  }

  renderLogout() {
    return (
      <form action="/api/logout" method="post">
        <button type="submit" className="logout-btn">
          <img src="/assets/icons/ic-d-connexion.svg" alt="Déconnexion" />
          Déconnexion
        </button>
      </form>
    )
  }

  renderMenuMobile() {
    return (
      <div id="menu-mobile" className={this.state.opened ? '' : 'hidden'}>
        <div className="overflow-y-auto">
          <div className="container-logo-close">
            {this.renderMobileLogo(true)}
            <div className="close-menu" onClick={() => this.toggleMenu()} />
          </div>
          <div className="menu-link">
            {this.renderNavigationLinks()}
            {this.renderLogout()}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { children } = this.props
    const disabledClass = this.isPaymentStatusUnpaid()
      ? ' main-nav-disabled'
      : ''

    return (
      <React.Fragment>
        <div className={`customer-area-main-nav main-nav${disabledClass}`}>
          <div className="nav-logo">
            <div className="customer-logo-container">
              <div className="drop-button" onClick={() => this.toggleMenu()} />
              {this.renderMobileLogo()}
            </div>
            <div className="desktop">
              <div className="customer-area-container">
                <div className="drop-button" onClick={() => this.toggleMenu()} />
                <div
                  className={`customer-nav-block ${this.state.opened ? '' : 'customer-nav-hidden'}`}
                >
                  {this.renderLogo()}
                  <div className="menu-links-desktop">{this.renderNavigationLinks()}</div>
                </div>
                <div className="customer-area-right">
                  <div className="customer-navigation-top">{this.renderLogout()}</div>
                  <div className="customer-area-content">{children}</div>
                </div>
              </div>
            </div>
          </div>
          {this.renderMenuMobile()}
        </div>
        <div className="customer-area-content-mobile">{children}</div>
      </React.Fragment>
    )
  }

  deactivateCaarlTour() {
    const { dispatch } = this.props
    dispatch(deactivateCaarlTour())
    axiosClient.post('/api/caarl/caarl-tour-done')
  }

  renderNavigationLinks() {
    const { currentPage, currentUser, caarlTourActive, dispatch } = this.props
    const disabled = this.isPaymentStatusUnpaid()

    return (
      <div className="h-full z-[999]">
        {currentUser.is_domiciliated_user && (
          <>
            {caarlTourActive && <CaarlTourOverlay onClick={this.deactivateCaarlTour.bind(this)} />}
            <CustomerNavigationLink
              closeMenu={() => this.closeMenu()}
              focus={currentPage}
              icon="ic-bo-te-aux-lettres"
              label="Boîte aux lettres"
              route="lettres"
              disabled={disabled}
            />
            <CustomerNavigationLink
              closeMenu={() => this.closeMenu()}
              focus={currentPage}
              icon="ic-adresse"
              label="Adresse"
              route="adresse"
              disabled={disabled}
            />
            <CustomerNavigationLink
              closeMenu={() => this.closeMenu()}
              focus={currentPage}
              icon="ic-abonnement"
              label="Abonnement"
              route="abonnement"
              disabled={disabled}
            />
            <CustomerNavigationLink
              closeMenu={() => this.closeMenu()}
              focus={currentPage}
              icon="ic-contrat"
              label="Contrat"
              route="contrat"
              disabled={disabled}
            />
          </>
        )}
        <CustomerNavigationLink
          closeMenu={() => this.closeMenu()}
          focus={currentPage}
          icon="ic-factures"
          label="Factures"
          route="factures"
          disabled={disabled}
        />
        {currentUser.is_domiciliated_user && (
          <CustomerNavigationLink
            closeMenu={() => this.closeMenu()}
            focus={currentPage}
            icon="moyen-de-paiement"
            label="Moyen de paiement"
            route="paiement"
            disabled={disabled}
          />)}
        <CustomerNavigationLink
          closeMenu={() => this.closeMenu()}
          focus={currentPage}
          icon="ic-contrat"
          label="Formalités"
          route="formalites"
          disabled={disabled}
        />
        {currentUser.is_domiciliated_user && (
          <>
            <CustomerNavigationLink
              closeMenu={() => this.closeMenu()}
              focus={currentPage}
              icon="ic-contrat"
              label="Compte pro"
              route="compte-pro"
              disabled={disabled}
            />
            <CustomerNavigationLink
              closeMenu={() => this.closeMenu()}
              focus={currentPage}
              icon="ic-contrat"
              label="Comptabilité"
              route="comptabilite"
              disabled={disabled}
            />
            <CustomerNavigationLink
              closeMenu={() => this.closeMenu()}
              focus={currentPage}
              icon="ic-contrat"
              label="Assurance"
              route="assurance"
              disabled={disabled}
            />
            <CustomerNavigationLink
              closeMenu={() => this.closeMenu()}
              focus={currentPage}
              icon="ic-contrat"
              label="Assistance juridique"
              route="assistance-juridique"
              disabled={disabled}
              caarlTourActive={caarlTourActive}
              additionnalOnClick={caarlTourActive ? this.deactivateCaarlTour.bind(this) : null}
            />
            <CustomerNavigationLink
              closeMenu={() => this.closeMenu()}
              focus={currentPage}
              icon="ic-contrat"
              label="Site internet"
              route="site-internet"
              disabled={disabled}
            />
          </>
        )}
        <Link to={'/contact'} target="_blank">
          <div className="customer-navigation-link">
            <div className="customer-navigation-icon">
              <img src="/assets/icons/ic-aide.svg" alt="Aide" />
            </div>
            <div>Aide</div>
          </div>
        </Link>
      </div>
    )
  }
}

const MapStateToProps = state => ({
  currentUser: state.user.currentUser,
  caarlTourActive: state.ui.caarlTourActive,
})

export default connect(MapStateToProps)(CustomerNavigation)
